import { render, staticRenderFns } from "./videoment.vue?vue&type=template&id=8d115866&scoped=true&"
import script from "./videoment.vue?vue&type=script&lang=js&"
export * from "./videoment.vue?vue&type=script&lang=js&"
import style0 from "./videoment.vue?vue&type=style&index=0&id=8d115866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d115866",
  null
  
)

export default component.exports